<form [formGroup]="form" autocomplete="off" class="form-horizontal">

  <div *commonUiOptionalWizardStep>
    <!-- SUMME UMSAETZE -->
    <div class="mb-5x">

      <h3>{{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.SUMME_UMSAETZE.TITEL' | translate }}</h3>

      <div class="form-row">
        <label class="col-sm-8 col-form-label" for="summeUmsaetzeJahrBetriebseroeffnung">
          {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.SUMME_UMSAETZE.BETREROEFFNUNG' | translate }}
        </label>
        <div class="col-sm-4">
          <input class="form-control text-right pr-3x" datevMessagePath="summeUmsaetzeJahrBetriebseroeffnung{{objectId}}" formControlName="summeUmsaetzeJahrBetriebseroeffnung"
                 id="summeUmsaetzeJahrBetriebseroeffnung" type="text" numeric transformNumber utilsCheckValidity
                 utilsControlState
                 utilsMarkRequired
                 utilsValidationMessage/>
          <em class="icon icon-euro"></em>
        </div>
      </div>

      <div class="form-row">
        <label class="col-sm-8 col-form-label" for="summeUmsaetzeFolgejahr">
          {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.SUMME_UMSAETZE.FOLGEJAHR' | translate }}
        </label>
        <div class="col-sm-4">
          <input class="form-control text-right pr-3x" datevMessagePath="summeUmsaetzeFolgejahr{{objectId}}" formControlName="summeUmsaetzeFolgejahr" id="summeUmsaetzeFolgejahr"
                 type="text" numeric transformNumber utilsCheckValidity utilsControlState utilsMarkRequired
                  utilsValidationMessage/>
          <em class="icon icon-euro"></em>
        </div>
      </div>
    </div>

    <!-- BISHERIGE UMSÄTZE -->
    <div *ngIf="activateBisherigeVerhaeltnisse" class="mb-5x">

      <h3>{{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.BISHERIGEVERHAELTNISSE.TITEL' | translate }}</h3>

      <div formGroupName="bisherigeVerhaeltnisse">
        <div class="form-row">
          <label class="col-sm-8 col-form-label" for="bereitsUmsatzsteuerlichGefuehrt">
            {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.BISHERIGEVERHAELTNISSE.SUBTITEL' | translate }}
          </label>
          <div class="col-sm-4">
            <select class="form-control" datevMessagePath="bereitsUmsatzsteuerlichGefuehrt{{objectId}}"
                    formControlName="bereitsUmsatzsteuerlichGefuehrt" id="bereitsUmsatzsteuerlichGefuehrt"
                    utilsCheckValidity utilsControlState utilsMarkRequired utilsValidationMessage>
              <option [ngValue]="null" selected>{{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.BISHERIGEVERHAELTNISSE.NULL_VALUE' |
                      translate }}</option>
              <option [ngValue]="true" selected>{{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.BISHERIGEVERHAELTNISSE.TRUE_VALUE' |
                      translate }}</option>
              <option [ngValue]="false" selected>{{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.BISHERIGEVERHAELTNISSE.FALSE_VALUE' |
                      translate }}</option>
            </select>
          </div>
        </div>
        <common-ui-steuernummer
                *ngIf="data.bisherigeVerhaeltnisse.bereitsUmsatzsteuerlichGefuehrt"
                [(data)]="data.bisherigeVerhaeltnisse.ordnungskriterium"
                [narrowInputFields]=true
                [readonly]="readonly">
        </common-ui-steuernummer>
      </div>
    </div>

    <!-- KLEINUNTERNEHMER -->
    <div class="mb-5x">

      <h3>{{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.KLEINUNTERNEHMER.TITEL' | translate }}</h3>

      <p class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.KLEINUNTERNEHMER.SUBTITEL' | translate }}</p>

      <common-ui-card [message]="'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.KLEINUNTERNEHMER.HINWEIS' | translate" class="mb-3x"
                      type="info"></common-ui-card>

      <div class="form-row">
        <label class="col-sm-8 col-form-label" for="kleinunternehmerRegelung">{{
          'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.KLEINUNTERNEHMER.LABEL' | translate }}
        </label>
        <div class="col-sm-4">
          <select class="form-control" datevMessagePath="kleinunternehmerRegelung{{objectId}}"
                  formControlName="kleinunternehmerRegelung" id="kleinunternehmerRegelung" utilsCheckValidity
                  utilsControlState
                  utilsMarkRequired utilsValidationMessage>
            <option [ngValue]="null" selected>{{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.KLEINUNTERNEHMER.NULL_VALUE' |
              translate }}</option>
            <option [ngValue]="true" selected>{{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.KLEINUNTERNEHMER.TRUE_VALUE' |
              translate }}</option>
            <option [ngValue]="false" selected>{{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.KLEINUNTERNEHMER.FALSE_VALUE' |
              translate }}</option>
          </select>
        </div>
      </div>

      <div *ngIf="data.kleinunternehmerRegelung === true" class="col-sm-12 col-lg-12 p-0"
           id="hinweisKleinunternehmerRegelung">
        <common-ui-card [message]="'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.KLEINUNTERNEHMER.HINWEIS_TRUE' | translate"
                        type="info"></common-ui-card>
      </div>

      <div *ngIf="data.kleinunternehmerRegelung === false" class="col-sm-12 col-lg-12 p-0"
           id="hinweisKeineKleinunternehmerRegelung">
        <common-ui-card [message]="'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.KLEINUNTERNEHMER.HINWEIS_FALSE' | translate"
                        type="info"></common-ui-card>
      </div>
    </div>

    <!-- SOLLISTVERSTEUERUNG -->
    <div class="mb-5x">

      <h3>{{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.SOLLISTVERSTEUERUNG.TITEL' | translate }}</h3>

      <div class="form-row">
        <label class="col-sm-8 col-form-label" for="sollIstVersteuerung">{{
          'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.SOLLISTVERSTEUERUNG.LABEL' | translate }}
        </label>
        <div class="col-sm-4">
          <select class="form-control" datevMessagePath="sollIstVersteuerung{{objectId}}" formControlName="sollIstVersteuerung"
                  id="sollIstVersteuerung" utilsCheckValidity utilsControlState utilsValidationMessage>
            <option [ngValue]="null" selected>{{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.SOLLISTVERSTEUERUNG.NULL_VALUE' |
              translate }}</option>
            <option *ngFor="let value of enumKeys(sollIstVersteuerungEnum)" [ngValue]="sollIstVersteuerungEnum[value]">
              {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.SOLLISTVERSTEUERUNG.KEY_' + sollIstVersteuerungEnum[value].toUpperCase() | translate }}
            </option>
          </select>
        </div>
      </div>

      <div *ngIf="data.sollIstVersteuerung === sollIstVersteuerungEnum.Istversteuerung">

        <div *ngIf="isIstVersteuerungRequired()" class="col-sm-12 col-lg-12 p-0 mb-3x" id="hinweisIstVersteuerung">
          <common-ui-card
            [message]="'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.SOLLISTVERSTEUERUNG.HINWEIS_ISTVERSTEUERUNG' | translate"
            type="info"></common-ui-card>
        </div>

        <div class="form-check">
          <input class="form-check-input" formControlName="istversteuerungGesamtumsatz" id="istversteuerungGesamtumsatz" type="checkbox"
                 utilsControlState>
          <label class="form-check-label" for="istversteuerungGesamtumsatz">
            {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.SOLLISTVERSTEUERUNG.ISTGESAMTUMSATZ' | translate }}
          </label>
        </div>

        <div class="form-check">
          <input class="form-check-input" formControlName="istversteuerungBefreiung" id="istversteuerungBefreiung" type="checkbox"
                 utilsControlState>
          <label class="form-check-label" for="istversteuerungBefreiung">{{
            'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.SOLLISTVERSTEUERUNG.ISTBEFREIUNG' | translate }}
          </label>
        </div>

        <div *ngIf="!isKapG && !isKapGAus">
          <div class="form-check">
            <input class="form-check-input" formControlName="istversteuerungFreierBeruf" id="istversteuerungFreierBeruf" type="checkbox"
                   utilsControlState>
            <label class="form-check-label" for="istversteuerungFreierBeruf">
              {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.SOLLISTVERSTEUERUNG.ISTFREIERBERUF' | translate }}
            </label>
          </div>
        </div>
      </div>
    </div>

    <!-- GESCHAEFTSVERAEUSSERUNG -->
    <div class="mb-5x">

      <h3>{{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.GESCHAEFTSVERAEUSSERUNG.TITEL' | translate }}</h3>

      <div class="form-row">
        <label class="col-sm-8 col-form-label" for="geschaeftsveraeusserungImGanzen">{{
          'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.GESCHAEFTSVERAEUSSERUNG.LABEL' | translate }}
        </label>
        <div class="col-sm-4">
          <select class="form-control" datevMessagePath="geschaeftsveraeusserungImGanzen{{objectId}}"
                  formControlName="geschaeftsveraeusserungImGanzen" id="geschaeftsveraeusserungImGanzen"
                  utilsCheckValidity
                  utilsControlState utilsValidationMessage>
            <option [ngValue]="null"
                    selected>{{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.GESCHAEFTSVERAEUSSERUNG.NULL_VALUE' |
              translate }}</option>
            <option [ngValue]="true"
                    selected>{{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.GESCHAEFTSVERAEUSSERUNG.TRUE_VALUE' |
              translate }}</option>
            <option [ngValue]="false"
                    selected>{{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.GESCHAEFTSVERAEUSSERUNG.FALSE_VALUE'
              | translate }}</option>
          </select>
        </div>
      </div>

      <div *ngIf="isKapGAus && data.geschaeftsveraeusserungImGanzen === true">
        <div class="form-row">
          <label class="col-sm-8 col-form-label" for="artUnternehmen">
            {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.GESCHAEFTSVERAEUSSERUNG.ARTUNTERNEHMEN' | translate }}
          </label>
          <div class="col-sm-4">
            <input class="form-control pr-3x" datevMessagePath="artUnternehmen{{objectId}}" formControlName="artUnternehmen" id="artUnternehmen"
                   type="text" utilsCheckValidity utilsControlState utilsMarkRequired
                   utilsValidationMessage/>
          </div>
        </div>

        <div class="form-row">
          <label class="col-sm-8 col-form-label" for="bezGesellshaft">
            {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.GESCHAEFTSVERAEUSSERUNG.BEZGESELLSHAFT' | translate }}
          </label>
          <div class="col-sm-4">
            <input class="form-control pr-3x" datevMessagePath="bezGesellshaft{{objectId}}" formControlName="bezGesellshaft" id="bezGesellshaft"
                   type="text" utilsCheckValidity utilsControlState utilsMarkRequired
                   utilsValidationMessage/>
          </div>
        </div>

        <common-ui-steuernummer [(data)]="data.stNrErworbBetrieb" [narrowInputFields]=true
                                [readonly]="readonly"></common-ui-steuernummer>

        <div class="form-row">
          <label class="col-sm-8 col-form-label" for="geschaeftsveraeusserungWirtschaftsIdNummer">
            {{ 'COMMON_UI.STEUERIDENTIFIKATION.WIRTSCHAFTS_ID_NUMMER' | translate }}
          </label>
          <div class="col-sm-4">
            <input class="form-control" datevMessagePath="geschaeftsveraeusserungWirtschaftsIdNummer{{objectId}}"
                   formControlName="geschaeftsveraeusserungWirtschaftsIdNummer"
                   id="geschaeftsveraeusserungWirtschaftsIdNummer"
                   type="text" utilsCheckValidity
                   utilsControlState
                   utilsValidationMessage/>
          </div>
        </div>

      </div>
    </div>

    <!-- ZAHLLAST -->
    <div class="mb-5x">

      <h3>{{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.ZAHLLAST.TITEL' | translate }}</h3>

      <div class="form-row">
        <label class="col-sm-8 col-form-label" for="auswahl">{{
          'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.ZAHLLAST.AUSWAHL_LABEL' | translate }}
        </label>
        <div class="col-sm-4">
          <select class="form-control" datevMessagePath="auswahl{{objectId}}" formControlName="auswahl"
                  id="auswahl" utilsCheckValidity utilsControlState utilsMarkRequired
                  utilsValidationMessage>
            <option [ngValue]="null" selected>{{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.ZAHLLAST.NULL_VALUE' |
              translate }}</option>
            <option *ngFor="let value of enumKeys(auswahlEnum)" [ngValue]="auswahlEnum[value]">
              {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.ZAHLLAST.KEY_' + auswahlEnum[value] | translate }}
            </option>
          </select>
        </div>
      </div>

      <div *ngIf="data.auswahl != null">
        <div class="form-row">
          <label class="col-sm-8 col-form-label" for="betrag">
            {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.ZAHLLAST.BETRAG_LABEL' | translate }}
          </label>
          <div class="col-sm-4">
            <input class="form-control text-right pr-3x" datevMessagePath="betrag{{objectId}}" formControlName="betrag"
                   id="betrag" type="text" numeric transformNumber utilsCheckValidity utilsControlState
                   utilsMarkRequired utilsValidationMessage/>
            <em class="icon-euro"></em>
          </div>
        </div>

        <div class="form-check">
          <input class="form-check-input" formControlName="voranmeldungMonatlich" id="voranmeldungMonatlich" type="checkbox"
                 utilsControlState>
          <label class="form-check-label" for="voranmeldungMonatlich">{{
            'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.ZAHLLAST.VORANMELDUNGMONATLICH_LABEL' | translate }}
          </label>
        </div>
      </div>
    </div>

    <!-- STEUERBEFREIUNG -->
    <div class="mb-5x">

      <h3>{{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.STEUERBEFREIUNG.TITEL' | translate }}</h3>

      <div class="form-row">
        <label class="col-sm-8 col-form-label" for="steuerfreieUmsaetze">{{
          'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.STEUERBEFREIUNG.LABEL' | translate }}
        </label>
        <div class="col-sm-4">
          <select class="form-control" datevMessagePath="steuerfreieUmsaetze{{objectId}}" formControlName="steuerfreieUmsaetze"
                  id="steuerfreieUmsaetze" utilsCheckValidity utilsControlState utilsValidationMessage>
            <option [ngValue]="null" selected>{{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.STEUERBEFREIUNG.NULL_VALUE' |
              translate }}</option>
            <option [ngValue]="true" selected>{{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.STEUERBEFREIUNG.TRUE_VALUE' |
              translate }}</option>
            <option [ngValue]="false" selected>{{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.STEUERBEFREIUNG.FALSE_VALUE' |
              translate }}</option>
          </select>
        </div>
      </div>

      <div *ngIf="data.steuerfreieUmsaetze != null && data.steuerfreieUmsaetze">
        <div class="form-row">
          <label class="col-sm-8 col-form-label" for="steuerfreieUmsaetzeNummer">
            {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.STEUERBEFREIUNG.NUMMER' | translate }}
          </label>
          <div class="col-sm-4">
            <input class="form-control" datevMessagePath="steuerfreieUmsaetzeNummer{{objectId}}" formControlName="steuerfreieUmsaetzeNummer" id="steuerfreieUmsaetzeNummer"
                   type="text" utilsCheckValidity utilsControlState
                   utilsMarkRequired
                   utilsValidationMessage/>
          </div>
        </div>

        <div class="form-row">
          <label class="col-sm-8 col-form-label" for="steuerfreieUmsaetzeArt">
            {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.STEUERBEFREIUNG.ART' | translate }}
          </label>
          <div class="col-sm-4">
            <input class="form-control" datevMessagePath="steuerfreieUmsaetzeArt{{objectId}}" formControlName="steuerfreieUmsaetzeArt" id="steuerfreieUmsaetzeArt"
                   type="text" utilsCheckValidity utilsControlState utilsMarkRequired
                   utilsValidationMessage/>
          </div>
        </div>
      </div>
    </div>

    <!-- STEUERSATZ -->
    <div class="mb-5x">

      <h3>{{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.STEUERSATZ.TITEL' | translate }}</h3>

      <div class="form-row">
        <label class="col-sm-8 col-form-label" for="steuerermaessigteUmsaetze">{{
          'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.STEUERSATZ.USTG2.LABEL' | translate }}
        </label>
        <div class="col-sm-4">
          <select class="form-control" datevMessagePath="steuerermaessigteUmsaetze{{objectId}}"
                  formControlName="steuerermaessigteUmsaetze" id="steuerermaessigteUmsaetze" utilsCheckValidity
                  utilsControlState utilsValidationMessage>
            <option [ngValue]="null"
                    selected>{{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.STEUERSATZ.USTG2.NULL_VALUE' | translate }}
            </option>
            <option [ngValue]="true"
                    selected>{{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.STEUERSATZ.USTG2.TRUE_VALUE' | translate }}
            </option>
            <option [ngValue]="false" selected>{{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.STEUERSATZ.USTG2.FALSE_VALUE' | translate
              }}</option>
          </select>
        </div>
      </div>

      <div *ngIf="data.steuerermaessigteUmsaetze != null && data.steuerermaessigteUmsaetze">
        <div class="form-row">
          <label class="col-sm-8 col-form-label" for="steuerermaessigteUmsaetzeNummer">
            {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.STEUERSATZ.USTG2.NUMMER' | translate }}
          </label>
          <div class="col-sm-4">
            <input class="form-control" datevMessagePath="steuerermaessigteUmsaetzeNummer{{objectId}}" formControlName="steuerermaessigteUmsaetzeNummer" id="steuerermaessigteUmsaetzeNummer"
                   type="text" utilsCheckValidity utilsControlState
                   utilsMarkRequired utilsValidationMessage/>
          </div>
        </div>

        <div class="form-row">
          <label class="col-sm-8 col-form-label" for="steuerermaessigteUmsaetzeArt">
            {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.STEUERSATZ.USTG2.ART' | translate }}
          </label>
          <div class="col-sm-4">
            <input class="form-control" datevMessagePath="steuerermaessigteUmsaetzeArt{{objectId}}" formControlName="steuerermaessigteUmsaetzeArt" id="steuerermaessigteUmsaetzeArt"
                   type="text" utilsCheckValidity utilsControlState
                   utilsMarkRequired
                   utilsValidationMessage/>
          </div>
        </div>
      </div>

      <!--####### KUKU - START ################################################################################## -->

      <div class="form-row">
        <label class="col-sm-8 col-form-label" for="steuerermaessigteUmsaetze2">{{
            'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.STEUERSATZ.USTG3.LABEL' | translate }}
        </label>
        <div class="col-sm-4">
          <select class="form-control" datevMessagePath="steuerermaessigteUmsaetze2{{objectId}}"
                  formControlName="steuerermaessigteUmsaetze2" id="steuerermaessigteUmsaetze2" utilsCheckValidity
                  utilsControlState utilsValidationMessage>
            <option [ngValue]="null"
                    selected>{{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.STEUERSATZ.USTG3.NULL_VALUE' | translate }}
            </option>
            <option [ngValue]="true"
                    selected>{{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.STEUERSATZ.USTG3.TRUE_VALUE' | translate }}
            </option>
            <option [ngValue]="false" selected>{{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.STEUERSATZ.USTG3.FALSE_VALUE' | translate
              }}</option>
          </select>
        </div>
      </div>

      <div *ngIf="data.steuerermaessigteUmsaetze2 !== null && data.steuerermaessigteUmsaetze2">
        <div class="form-row">
          <label class="col-sm-8 col-form-label" for="steuerermaessigteUmsaetzeArt2">
            {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.STEUERSATZ.USTG3.ART' | translate }}
          </label>
          <div class="col-sm-4">
            <input class="form-control" datevMessagePath="steuerermaessigteUmsaetzeArt2{{objectId}}" formControlName="steuerermaessigteUmsaetzeArt2" id="steuerermaessigteUmsaetzeArt2"
                   type="text" utilsCheckValidity utilsControlState
                   utilsMarkRequired
                   utilsValidationMessage/>
          </div>
        </div>

        <div class="form-row mb-2x">
          <div class="form-check">
            <input class="form-check-input" formControlName="steuerermaessigteUmsaetzeArt2UStG1" id="steuerermaessigteUmsaetzeArt2UStG1" type="checkbox"
                   utilsControlState>
            <label class="form-check-label" for="steuerermaessigteUmsaetzeArt2UStG1">
              {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.STEUERSATZ.USTG3.USTG_1' | translate }}
            </label>
          </div>
        </div>

        <div class="form-row mb-2x">
          <div class="form-check">
            <input class="form-check-input" formControlName="steuerermaessigteUmsaetzeArt2UStG2" id="steuerermaessigteUmsaetzeArt2UStG2" type="checkbox"
                   utilsControlState>
            <label class="form-check-label" for="steuerermaessigteUmsaetzeArt2UStG2">
              {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.STEUERSATZ.USTG3.USTG_2' | translate }}
            </label>
          </div>
        </div>

        <div class="form-row mb-2x">
          <div class="form-check">
            <input class="form-check-input" formControlName="steuerermaessigteUmsaetzeArt2UStG3" id="steuerermaessigteUmsaetzeArt2UStG3" type="checkbox"
                   utilsControlState>
            <label class="form-check-label" for="steuerermaessigteUmsaetzeArt2UStG3">
              {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.STEUERSATZ.USTG3.USTG_3' | translate }}
            </label>
          </div>
        </div>

        <div class="form-row mb-2x">
          <div class="form-check">
            <input class="form-check-input" formControlName="steuerermaessigteUmsaetzeArt2UStG4" id="steuerermaessigteUmsaetzeArt2UStG4" type="checkbox"
                   utilsControlState>
            <label class="form-check-label" for="steuerermaessigteUmsaetzeArt2UStG4">
              {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.STEUERSATZ.USTG3.USTG_4' | translate }}
            </label>
          </div>
        </div>
      </div>
    </div>

    <!--####### KUKU - END ################################################################################ -->

    <!-- DURCHSCHNITTSSATZBESTEUERUNG -->
    <div class="mb-5x">

      <h3>{{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.DURCHSCHNITTSSATZBESTEUERUNG.TITEL' | translate }}</h3>

      <div
        *ngIf="data.durchschnittsbesteuerteUmsaetze!= null && data.durchschnittsbesteuerteUmsaetze && data.kleinunternehmerRegelung !== null"
        class="mb-3x">
        <common-ui-card [message]="'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.DURCHSCHNITTSSATZBESTEUERUNG.WARNING' | translate"
                        type="danger"></common-ui-card>
      </div>

      <div class="form-row">
        <label class="col-sm-8 col-form-label" for="durchschnittsbesteuerteUmsaetze">{{
          'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.DURCHSCHNITTSSATZBESTEUERUNG.LABEL' | translate }}
        </label>
        <div class="col-sm-4">
          <select class="form-control" datevMessagePath="durchschnittsbesteuerteUmsaetze{{objectId}}"
                  formControlName="durchschnittsbesteuerteUmsaetze" id="durchschnittsbesteuerteUmsaetze"
                  utilsCheckValidity
                  utilsControlState utilsValidationMessage>
            <option [ngValue]="null" selected>{{
              'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.DURCHSCHNITTSSATZBESTEUERUNG.NULL_VALUE' | translate }}</option>
            <option [ngValue]="true" selected>{{
              'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.DURCHSCHNITTSSATZBESTEUERUNG.TRUE_VALUE' | translate }}</option>
            <option [ngValue]="false" selected>{{
              'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.DURCHSCHNITTSSATZBESTEUERUNG.FALSE_VALUE' | translate }}</option>
          </select>
        </div>
      </div>

      <div *ngIf="data.durchschnittsbesteuerteUmsaetze != null && data.durchschnittsbesteuerteUmsaetze">

        <div class="form-row">
          <label class="col-sm-8 col-form-label" for="durchschnittsbesteuerteUmsaetzeNummer">
            {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.DURCHSCHNITTSSATZBESTEUERUNG.NUMMER' | translate }}
          </label>
          <div class="col-sm-4">
            <input class="form-control" datevMessagePath="durchschnittsbesteuerteUmsaetzeNummer{{objectId}}"
                   formControlName="durchschnittsbesteuerteUmsaetzeNummer" id="durchschnittsbesteuerteUmsaetzeNummer"
                   type="text" utilsCheckValidity utilsControlState utilsMarkRequired
                   utilsValidationMessage/>
          </div>
        </div>

        <div class="form-row">
          <label class="col-sm-8 col-form-label" for="durchschnittsbesteuerteUmsaetzeArt">
            {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.DURCHSCHNITTSSATZBESTEUERUNG.ART' | translate }}
          </label>
          <div class="col-sm-4">
            <input class="form-control" datevMessagePath="durchschnittsbesteuerteUmsaetzeArt{{objectId}}" formControlName="durchschnittsbesteuerteUmsaetzeArt" id="durchschnittsbesteuerteUmsaetzeArt"
                   type="text" utilsCheckValidity utilsControlState
                   utilsMarkRequired utilsValidationMessage/>
          </div>
        </div>

        <div class="form-row">
          <div  class="form-check mb-1x">
            <input class="form-check-input"
                   formControlName="anspruchDurchschnittsbesteuerung"
                   id="anspruchDurchschnittsbesteuerung" type="checkbox" utilsControlState>
            <label class="form-check-label" for="anspruchDurchschnittsbesteuerung">
              {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.DURCHSCHNITTSSATZBESTEUERUNG.ANSPRUCH' | translate }}
            </label>
          </div>
        </div>

        <div class="form-row">
          <div  class="form-check mb-1x">
            <input class="form-check-input"
                   formControlName="verzichtDurchschnittsbesteuerung"
                   id="verzichtDurchschnittsbesteuerung" type="checkbox" utilsControlState>
            <label class="form-check-label" for="verzichtDurchschnittsbesteuerung">
              {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.DURCHSCHNITTSSATZBESTEUERUNG.VERZICHT' | translate }}
            </label>
          </div>
        </div>
      </div>
    </div>

    <!-- USTID -->
    <div class="mb-5x">

      <h3>{{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.USTID.TITEL' | translate }}</h3>

      <div  class="form-check mb-1x">
        <input (change)="onBenoetigtChanged()" class="form-check-input" formControlName="ustIdentifikationsnummerBenoetigt"
               id="ustIdentifikationsnummerBenoetigt" type="checkbox" utilsControlState>
        <label *ngIf="!isKapG && !isKapGAus && !isPersG" class="form-check-label" for="ustIdentifikationsnummerBenoetigt">{{
          'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.USTID.BENOETIGT' | translate }}
        </label>
        <label *ngIf="isKapG || isKapGAus || isPersG" class="form-check-label" for="ustIdentifikationsnummerBenoetigt">{{
          'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.USTID.BENOETIGT_ALT_TEXT' | translate }}
        </label>
      </div>

      <div *ngIf="(isKapG || isKapGAus) && data.ustIdentifikationsnummerBenoetigt">
        <div class="mb-1x">
          <p>
            {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.USTID.BENOETIGT_GRUND' | translate }}
          </p>
        </div>
        <div class="radio-button">
          <input [value]="null" class="radio-button-selection"
                 formControlName="ustIdentifikationsnummerWirdBeantragtGrund" id="ustIdentifikationsnummerWirdBeantragtGrundNull"
                 type="radio"/>
          <label class="radio-button-text" for="ustIdentifikationsnummerWirdBeantragtGrundNull">
            {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.USTID.GRUND_NULL' | translate }}
          </label>
        </div>
        <div *ngFor="let value of enumKeys(steuerIdAntragGrundEnum)" class="radio-button">
          <input [value]="steuerIdAntragGrundEnum[value]" class="radio-button-selection"
                 formControlName="ustIdentifikationsnummerWirdBeantragtGrund" id="ustIdentifikationsnummerWirdBeantragtGrund{{steuerIdAntragGrundEnum[value]}}"
                 type="radio"/>
          <label class="radio-button-text"
                 for="ustIdentifikationsnummerWirdBeantragtGrund{{steuerIdAntragGrundEnum[value]}}">
            {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.USTID.GRUND_' + steuerIdAntragGrundEnum[value] | translate }}
          </label>
        </div>
      </div>

      <!-- Zusatzangaben für juristische Person -->
      <div *ngIf="isKapG || isKapGAus">
        <h3 class="mt-5x">
          {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.USTID.JURISTISCHE_PERSON' | translate }}
        </h3>

        <div class="col-sm-12 col-lg-12 p-0 mt-2x mb-3x" id="hinweisUstBenoetigt">
          <div>
            <common-ui-card [message]="'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.USTID.JURISTISCHE_PERSON_HINWEIS'  | translate"
                            type="info"></common-ui-card>
          </div>
        </div>
      </div>

      <div class="form-check">
        <input class="form-check-input" formControlName="ustIdentifikationsnummerVorhanden" id="ustIdentifikationsnummerVorhanden"
               type="checkbox" utilsControlState>
        <label class="form-check-label" for="ustIdentifikationsnummerVorhanden">
          {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.USTID.VORHANDEN' | translate }}
        </label>
      </div>

      <div *ngIf="data.ustIdentifikationsnummerVorhanden != null && data.ustIdentifikationsnummerVorhanden">

        <div class="form-row mt-2x">
          <label class="col-sm-8 col-form-label" for="ustIdentifikationsnummer">
            {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.USTID.VORHANDEN_ID' | translate }}
          </label>
          <div class="col-sm-4">
            <input class="form-control" datevMessagePath="ustIdentifikationsnummer{{objectId}}" formControlName="ustIdentifikationsnummer" id="ustIdentifikationsnummer"
                   type="text" utilsCheckValidity utilsControlState
                   utilsMarkRequired
                   utilsValidationMessage/>
          </div>
        </div>

        <div class="form-row">
          <label class="col-sm-8 col-form-label" for="ustIdentifikationsnummerVergabedatum">
            {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.USTID.VORHANDEN_VERGABEDATUM' | translate }}
          </label>
          <div class="col-sm-4">
            <date-picker
                    id="ustIdentifikationsnummerVergabedatum"
                    messagePath="ustIdentifikationsnummerVergabedatum"
                    formControlName="ustIdentifikationsnummerVergabedatum"
                    [isRequired]=false>
            </date-picker>
          </div>
        </div>
      </div>

    </div>

    <!-- VERGUETUN VON VORSTEUER -->
    <div *ngIf="isKapGAus" class="mb-5x">

      <h3>{{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.VERGUETUNG_VON_VORSTEUER.TITEL' | translate }}</h3>

      <div class="form-row">
        <label class="col-sm-8 col-form-label" for="antragVoSt">{{
          'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.VERGUETUNG_VON_VORSTEUER.FUER_DAS_UNTERNEHMEN' | translate }}
        </label>
        <div class="col-sm-4">
          <select class="form-control" datevMessagePath="antragVoSt{{objectId}}"
                  formControlName="antragVoSt" id="antragVoSt" utilsCheckValidity
                  utilsControlState utilsValidationMessage>
            <option [ngValue]="null" selected>{{
              'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.VERGUETUNG_VON_VORSTEUER.NULL_VALUE' | translate }}</option>
            <option [ngValue]="true" selected>{{
              'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.VERGUETUNG_VON_VORSTEUER.TRUE_VALUE' | translate }}</option>
            <option [ngValue]="false" selected>{{
              'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.VERGUETUNG_VON_VORSTEUER.FALSE_VALUE' | translate }}</option>
          </select>
        </div>
      </div>
      <div *ngIf="data.antragVoSt">
        <div class="form-row">
          <label class="col-sm-8 col-form-label" for="zeitraumVon">
            {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.VERGUETUNG_VON_VORSTEUER.ZEITRAUM_VOM' | translate }}
          </label>
          <div class="col-sm-4">
            <date-picker
                    id="zeitraumVon"
                    messagePath="zeitraumVon"
                    formControlName="zeitraumVon"
                    [isRequired]=true>
            </date-picker>
          </div>
        </div>

        <div class="form-row">
          <label class="col-sm-8 col-form-label" for="zeitraumBis">
            {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.VERGUETUNG_VON_VORSTEUER.ZEITRAUM_BIS' | translate }}
          </label>
          <div class="col-sm-4">
            <date-picker
                    id="zeitraumBis"
                    messagePath="zeitraumBis"
                    formControlName="zeitraumBis"
                    [isRequired]=true>
            </date-picker>
          </div>
        </div>

        <div class="form-row">
          <label class="col-sm-8 col-form-label" for="aktenzeichen">
            {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.VERGUETUNG_VON_VORSTEUER.AKTENZEICHEN' | translate }}
          </label>
          <div class="col-sm-4">
            <input class="form-control" datevMessagePath="aktenzeichen{{objectId}}" formControlName="aktenzeichen" id="aktenzeichen"
                   type="text" utilsCheckValidity
                   utilsControlState utilsMarkRequired
                   utilsValidationMessage/>
          </div>
        </div>
      </div>
    </div>

    <!-- VERGUETUN VON VORSTEUER -->
    <div *ngIf="isKapGAus" class="mb-5x">

      <h3>{{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.EORI_NUMMER.TITEL' | translate }}</h3>

      <div class="col-sm-12 col-lg-12 p-0 mt-2x mb-3x" id="infoEORINummer">
        <common-ui-card [message]="'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.EORI_NUMMER.INFO' | translate"
                        type="info"></common-ui-card>
      </div>

      <div class="form-row">
        <label class="col-sm-8 col-form-label" for="eoriNummer">
          {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.EORI_NUMMER.LABEL' | translate }}
        </label>
        <div class="col-sm-4">
          <input class="form-control" datevMessagePath="eoriNummer{{objectId}}" formControlName="eoriNummer" id="eoriNummer"
                 type="text" utilsCheckValidity
                 utilsControlState utilsMarkRequired
                 utilsValidationMessage/>
        </div>
      </div>
    </div>

    <!-- STEUERSCHULDNERSCHAFT -->
    <div class="mb-5x">

      <h3>{{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.STEUERSCHULDNERSCHAFT.TITEL' | translate }}</h3>

      <div class="col-sm-12 col-lg-12 p-0 mt-2x mb-3x" id="hinweisSteuerschuldnerschaft">
        <common-ui-card [message]="'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.STEUERSCHULDNERSCHAFT.HINWEIS' | translate"
                        type="info"></common-ui-card>
      </div>

      <div class="form-check">
        <input class="form-check-input" formControlName="nachweisSteuerschuldnerschaft" id="nachweisSteuerschuldnerschaft" type="checkbox"
               utilsControlState>
        <label class="form-check-label" for="nachweisSteuerschuldnerschaft">
          {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.STEUERSCHULDNERSCHAFT.BEANTRAGT' | translate }}
        </label>
      </div>

      <div *ngIf="data.nachweisSteuerschuldnerschaft != null && data.nachweisSteuerschuldnerschaft" class="ml-3x">

        <div *ngIf="!data.nachweisSteuerschuldnerschaftBauleistungen && !data.nachweisSteuerschuldnerschaftGebaeudereinigungsleistungen"
             class="col-sm-12 col-lg-12 p-0 mt-2x mb-3x"
             id="hinweisSteuerschuldnerschaftKeineAngabe">
          <common-ui-card
            [message]="'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.STEUERSCHULDNERSCHAFT.HINWEIS_KEINE_ANGABE' | translate"
            type="danger"></common-ui-card>
        </div>

        <div class="form-check">
          <input class="form-check-input" formControlName="nachweisSteuerschuldnerschaftBauleistungen" id="nachweisSteuerschuldnerschaftBauleistungen"
                 type="checkbox" utilsControlState>
          <label class="form-check-label" for="nachweisSteuerschuldnerschaftBauleistungen">
            {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.STEUERSCHULDNERSCHAFT.BEANTRAGT_BAU' | translate }}
          </label>
        </div>

        <div class="form-check">
          <input class="form-check-input" formControlName="nachweisSteuerschuldnerschaftGebaeudereinigungsleistungen" id="nachweisSteuerschuldnerschaftGebaeudereinigungsleistungen"
                 type="checkbox" utilsControlState>
          <label class="form-check-label" for="nachweisSteuerschuldnerschaftGebaeudereinigungsleistungen">
            {{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.STEUERSCHULDNERSCHAFT.BEANTRAGT_GEBAEUDE' | translate }}
          </label>
        </div>
      </div>
    </div>
  </div>

</form>
